export default __webpack_public_path__ + "static/goods-3-bd859790ca66c7e8bf6e73d65e794cd7.png";